import type { Price, PromotionPrice } from '@expert/types';

export const getCompactPromotionFromIndex = (promotionId: string): CompactPromotion | undefined => {
    const index: PromotionIndex | undefined = useNuxtData<PromotionIndex>(`promotion/index`)
        .data.value;
    return index?.globalPromotions[promotionId];
};

export const getPromotionForModification = (modificationId: string): ArticlePromotion | undefined => {
    const index: PromotionIndex | undefined = useNuxtData<PromotionIndex>(`promotion/index`)
        .data.value;
    return getPromotionForModificationFromIndex(index, modificationId);
};

export const getPromotionsForArticle = (articleId: string, price?: Price): Array<ArticlePromotion> => {
    const index: PromotionIndex | undefined = useNuxtData<PromotionIndex>(`promotion/index`)
        .data.value;
    return getPromotionsForArticleFromIndex(index, articleId, price);
};

export const getArticlePromotionPrice = (articleId: string, price: Price): PromotionPrice => {
    const index: PromotionIndex | undefined = useNuxtData<PromotionIndex>(`promotion/index`)
        .data.value;
    return getArticlePromotionPriceFromIndex(index, articleId, price);
};
